import { render } from "./NewPassword.vue?vue&type=template&id=058b4f44&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=058b4f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b4f44"]])

export default __exports__